import React from "react";
import { connect } from "react-redux";
import AppLayout from "../../components/Layout";
import { getRedirectPath, isSuperAdmin } from "../../constants/user";
import Redirect from "../../components/Redirect";

function Admin({
  authentication: { user },
  match,
}) {
  // return (
  //   <React.Fragment>
  //     <Sidenav match={match} module="admin" />
  //     <div className="component-view">
  //       <Switch>
  //         {routes.map((route, i) => (
  //           <AdminRouter key={i} {...route} />
  //         ))}
  //       </Switch>
  //     </div>
  //   </React.Fragment>
  // );

  return user && isSuperAdmin(user) ? <AppLayout
    match={match}
    module="admin"
  /> : <Redirect to={getRedirectPath(user, '')} />;
}

export default connect(({ authentication }) => ({ authentication }))(Admin);
